import * as Yup from 'yup';
import i18n from '../../../i18n';

const billingAddressValidationSchema = Yup.object().shape({
  billing_name: Yup.string().required(
    i18n.t('billingaddresses.validation.billing_name'),
  ),
  address_line1: Yup.string().required(
    i18n.t('billingaddresses.validation.address_line1'),
  ),
  postal_code: Yup.string().required(
    i18n.t('billingaddresses.validation.postal_code'),
  ),
  city: Yup.string().required(i18n.t('billingaddresses.validation.city')),
  label: Yup.string(),
  // country is optional (API rule is `sometimes|size:2`): a 2-letter code when
  // provided, but an empty field is allowed — the API defaults it to "FR".
  country: Yup.string().matches(/^[A-Za-z]{2}$/, {
    message: i18n.t('billingaddresses.validation.country'),
    excludeEmptyString: true,
  }),
});

export default billingAddressValidationSchema;
